import React from "react";
import '../../App.css';
import Cards from '../Cards';
import HeroSection from '../HeroSection';

export default function Home() {
  return (
    <>
      <HeroSection />
      <Cards />
    </>
  );
}